import { API_PREFIX } from "./api.constants";

export const POSITION_ENDPOINTS = {
  POSITIONS: `${API_PREFIX}/positions/`,
  POSITION_DETAIL: (posId: number | string) => `${API_PREFIX}/positions/${posId}`,
  POSITIONS_EXPORT: `${API_PREFIX}/positions/export`,
  POSITIONS_CUSTOM_FIELDS: `${API_PREFIX}/positions/custom-fields/`,
  POSITION_CUSTOM_FIELD_DETAIL: (definitionId: number | string) => `${API_PREFIX}/positions/custom-fields/${definitionId}`,
};